import React from 'react';
import { LoadingButton } from "@mui/lab";
import { useLang } from "~/hooks/useLang";

interface GenerateReportButton {
    readonly isLoading: boolean;
    readonly makeReport: () => void;
    readonly disabled?: boolean
}

export default function GenerateReportButton({ isLoading, makeReport, disabled = false }: GenerateReportButton) {
    const { translate } = useLang();

    return (
        <LoadingButton
            loading={isLoading}
            variant="contained"
            onClick={() => makeReport()}
            disabled={disabled}
        >
            {translate('Generate report')}
        </LoadingButton>
    )
}